import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { Link } from 'gatsby';
import styled from 'styled-components';
import { A } from '../../../styles/common/Typo';
import tw from 'twin.macro';
import { LocaleContext } from '../../layout/layout';
import parse from 'html-react-parser';

export default function FormComponent() {
  const lang = React.useContext(LocaleContext)
  const i18n = lang.i18n[lang.locale]
  const { register, handleSubmit, errors, reset, formState } = useForm();
  const [
    isSuccessfullySubmitted,
    setIsSuccessfullySubmitted,
  ] = React.useState(false);

  // Handles the post process to Netlify so we can access their serverless functions
  const handlePost = (formData, event) => {
    fetch(`/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact-form", ...formData }),
    })
      .then((response) => {
        setIsSuccessfullySubmitted(response.ok);
        reset()
      })
      .catch((error) => {
        alert('Error');
      })
    event.preventDefault()
  }

  // Transforms the form data from the React Hook Form output to a format Netlify can read
  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&")
  }

  return (
    <>
      {isSuccessfullySubmitted && (
        <div className="text-white px-6 py-4 border-0 rounded relative mb-4 bg-green-500">
          <span className="inline-block align-middle mr-8">
            {i18n.contactForm.successfullySubmittedMessage}
          </span>
        </div>
      )}
      <form
        onSubmit={handleSubmit(handlePost)}
        name="contact-form"
        method="POST"
        action="/success/"
        data-netlify="true"
        netlify-honeypot="got-ya"
        className="flex flex-col md:flex-row flex-wrap"
      >
        <div className="p-0 md:pr-2 md:pt-2 w-full md:w-1/2">
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block" htmlFor="name">
                <span className="text-gray-700">{i18n.contactForm.name}</span>
                <input
                  type="text"
                  name="name"
                  data-lpignore="true"
                  className="mt-1 block w-full border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  placeholder={i18n.contactForm.namePlaceholder}
                  ref={register({ required: true })} />
                {errors.name && errors.name.type === "required" && (
                  <div className="text-red-500">{i18n.contactForm.errors.name}</div>
                )}
              </label>
            </div>
            <div className="w-full md:w-1/2 px-3 mb-0 md:mb-0">
              <label className="block" htmlFor="email">
                <span className="text-gray-700">{i18n.contactForm.mail}</span>
                <input
                  type="email"
                  name="email"
                  data-lpignore="true"
                  className="mt-1 block w-full border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  placeholder={i18n.contactForm.mailPlaceholder}
                  ref={register({
                    required: true,
                    pattern: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
                  })}
                />
                {errors.email && errors.email.type === "required" && (
                  <div className="text-red-500">{i18n.contactForm.errors.mail}</div>
                )}
              </label>
            </div>
          </div>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label className="block" htmlFor="name">
                <span className="text-gray-700">{i18n.contactForm.phone}</span>
                <input
                  type="text"
                  name="phone"
                  data-lpignore="true"
                  className="mt-1 block w-full border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  placeholder={i18n.contactForm.phonePlaceholder}
                  ref={register()} />
              </label>
            </div>
            <div className="w-full md:w-1/2 px-3 mb-0 md:mb-0">
              <label className="block" htmlFor="email">
                <span className="text-gray-700">{i18n.contactForm.website}</span>
                <input
                  type="text"
                  name="website"
                  data-lpignore="true"
                  className="mt-1 block w-full border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  placeholder={i18n.contactForm.websitePlaceholder}
                  ref={register()}
                />
              </label>
            </div>
          </div>
        </div>
        <div className="py-4 md:py-0 md:pl-2 md:pt-2 w-full md:w-1/2">
          <label className="block" htmlFor="nachricht">
            <span className="text-gray-700">{i18n.contactForm.message}</span>
            <textarea name="nachricht"
              data-lpignore="true"
              className="resize-none mt-1 block w-full border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50" rows="5" ref={register({ required: true })}></textarea>
            {errors.nachricht && errors.nachricht.type === "required" && (
              <div className="text-red-500">{i18n.contactForm.errors.message}</div>
            )}
          </label>
          <label
            htmlFor="got-ya"
            style={{
              position: "absolute",
              overflow: "hidden",
              clip: "rect(0 0 0 0)",
              height: "1px",
              width: "1px",
              margin: "-1px",
              padding: "0",
              border: "0",
            }}
          >
            Don’t fill this out if you're human:
              <input tabIndex="-1" name="got-ya" ref={register()} />
          </label>
        </div>
        <div className="p-0 md:py-4 w-full md:w-full">
          <label className="block mb-4" htmlFor="terms">
            <input
              type="checkbox"
              name="terms"
              ref={register({ required: true })}
              className="form-checkbox" />
            <span className="ml-2">{parse(i18n.contactForm.terms)}</span>

            {errors.terms && errors.terms.type === "required" && (
              <div className="text-red-500">{i18n.contactForm.errors.terms}</div>
            )}
          </label>

          <button
            disabled={formState.isSubmitting || isSuccessfullySubmitted}
            type="submit"
            className="block text-center bg-gray-400 px-6 py-4 text-xl leading-6 font-semibold font-display text-white hover:bg-gray-600 focus:outline-none focus:shadow-outline transition ease-in-out duration-150">{i18n.contactForm.submitButton}</button>
        </div>
      </form>
    </>
  )
}
